<template>
  <div
    class="funnel-container"
    @wheel.prevent="handleWheel"
    @mousemove="handleMove"
    @mousedown="handleDown"
    @mouseup="handleUp"
  >
    <!-- <div class="controls">
      <button class="zoomIn" @click="zoomIn">
        <i class="fa-regular fa-plus" />
      </button>
      <span class="percentage">
        {{ parseFloat(scale * 100).toFixed(2) }}%
      </span>
      <button class="zoomOut" @click="zoomOut">
        <i class="fa-regular fa-minus" />
      </button>
      <button class="centering" @click="centering">
        <i class="fa-regular fa-crosshairs-simple" />
      </button>
    </div> -->

    <span v-if="saving" class="saving">
      <!-- Salvando alterações -->
      <b-spinner variant="primary" />
    </span>

    <funnel-connections :links="links" />

    <funnel-item
      v-for="(step, i) in tree"
      :funnel="step"
      :selected="selectedStep === step.id"
      :key="i"
      :options="optionsForChild"
      @edit="editStep"
      @add="createStep"
      @update="dispatchScene"
      @select="selectStep(step.id)"
      @delete="deleteStep(step.id)"
    />

    <responsive-modal
      v-model="modal"
      :title="stepToEdit.id ? 'Editar etapa' : 'Próxima etapa'"
    >
      <step-form
        v-if="modal"
        :action="action"
        :stepToEdit="stepToEdit"
        @close="modal = false"
        @addStep="centering"
      />
    </responsive-modal>
  </div>
</template>

<script>
import mouseHelper from "@/functions/mouse";
import { mapState } from "vuex";
import FunnelConnections from "./FunnelConnections.vue";
import FunnelItem from "./FunnelItem.vue";
import StepForm from "./StepForm.vue";

let timeout;
export default {
  name: "FunnelContainer",
  components: {
    StepForm,
    FunnelConnections,
    FunnelItem
  },
  data() {
    return {
      modal: false,
      action: null,
      saving: false,
      stepToEdit: {},
      selectedStep: null,

      mouseX: 0,
      mouseY: 0,
      lastMouseX: 0,
      lastMouseY: 0,
      dragging: false,
      hasDragged: false,

      centerX: 0,
      centerY: 0,
      scale: 1,
      maxScale: 5,
      minScale: 0.2
    };
  },
  mounted() {
    // positioning if created in older version of the funnel
    if (this.tree[1]?.position_x === null) {
      let tree = [...this.tree].slice(1);

      tree.forEach((step, i) => {
        let parent = this.tree.find(f => f.id === step.parent);
        tree[i].position_y =
          i == 0
            ? 0
            : parent.action_no && parent.action_no.id === step.id
            ? parent.position_y + 200
            : parent.position_y - 200;
        tree[i].position_x = parent.position_x + 550;
      });

      this.$store.commit("funnel/setTree", [this.tree[0], ...tree]);
    }

    this.centering();
  },
  computed: {
    ...mapState("funnel", ["tree"]),
    optionsForChild() {
      return {
        width: 340,
        titleHeight: 20,
        scale: this.scale,
        center: {
          x: this.centerX,
          y: this.centerY
        }
      };
    },
    links() {
      let links = [];
      let treeMap = new Map(this.tree.map(step => [step.id, step]));

      this.tree.forEach(step => {
        if (step.action_yes) {
          let target = treeMap.get(step.action_yes.id);
          links.push(this.generateLink(step, target, "yes"));
        }

        if (step.action_no) {
          let target = treeMap.get(step.action_no.id);
          links.push(this.generateLink(step, target, "no"));
        }
      });

      if (this.tree.length > 1) {
        links.push(this.generateLink(this.tree[0], this.tree[1]));
      }

      return links;
    }
  },
  methods: {
    generateLink(originStep, targetStep, action = "") {
      let x1 = this.getConnectionPos(originStep, false).x;
      let offset = action ? 120 * this.scale : 20;
      let y1 = this.getConnectionPos(originStep, false).y - offset;
      let x2 = this.getConnectionPos(targetStep, true).x - 20 * this.scale;
      let y2 = this.getConnectionPos(targetStep, true).y - 60 * this.scale;

      let style = {
        stroke: action == "no" ? "#FF3F34" : "#00B837DB",
        strokeWidth: 3 * this.scale,
        fill: "none"
      };

      return { x1, y1, x2, y2, style };
    },

    editStep(step) {
      this.stepToEdit = { ...step };
      this.modal = true;
    },
    createStep(action, step) {
      this.stepToEdit = step;
      this.action = action;
      this.modal = true;
    },
    /** @param e {MouseEvent} */
    handleMove(e) {
      let mouse = mouseHelper.getMousePosition(this.$el, e);
      this.mouseX = mouse.x;
      this.mouseY = mouse.y;

      if (this.dragging) {
        let diffX = this.mouseX - this.lastMouseX;
        let diffY = this.mouseY - this.lastMouseY;

        this.lastMouseX = this.mouseX;
        this.lastMouseY = this.mouseY;

        this.centerX += diffX;
        this.centerY += diffY;

        this.hasDragged = true;
      }
    },
    handleDown(e) {
      const target = e.target || e.srcElement;
      if (
        (target === this.$el || target.matches("svg, svg *")) &&
        e.which === 1
      ) {
        this.dragging = true;

        let mouse = mouseHelper.getMousePosition(this.$el, e);
        this.mouseX = mouse.x;
        this.mouseY = mouse.y;

        this.lastMouseX = this.mouseX;
        this.lastMouseY = this.mouseY;

        this.selectedStep = null;
        if (e.preventDefault) e.preventDefault();
      }
    },
    handleUp() {
      if (this.dragging) {
        this.dragging = false;
      }
    },
    handleWheel(e) {
      const target = e.target || e.srcElement;
      if (this.$el.contains(target)) {
        if (e.preventDefault) e.preventDefault();
        let deltaScale = Math.pow(1.1, e.deltaY * -0.01);
        this.scale *= deltaScale;

        if (this.scale < this.minScale) {
          this.scale = this.minScale;
          return;
        } else if (this.scale > this.maxScale) {
          this.scale = this.maxScale;
          return;
        }

        let zoomingCenter = {
          x: this.mouseX,
          y: this.mouseY
        };

        let deltaOffsetX = (zoomingCenter.x - this.centerX) * (deltaScale - 1);
        let deltaOffsetY = (zoomingCenter.y - this.centerY) * (deltaScale - 1);

        this.centerX -= deltaOffsetX;
        this.centerY -= deltaOffsetY;
      }
    },
    getConnectionPos(step, isInput) {
      if (!step) return undefined;

      let x = 0;
      let y = 0;

      x += step.position_x;
      y += step.position_y;

      // (height / 2 + stepBorder + padding)
      y -= 50 / 2 + 1 + 2;
      if (!isInput) {
        x += this.optionsForChild.width;

        //  + (height * slotNumber)
        if (step.funnel?.cta_text && step.funnel?.ctb_text) y -= 40;
      }

      x *= this.scale;
      y *= this.scale;

      x += this.centerX;
      y += this.centerY;

      return { x, y };
    },
    selectStep(id) {
      this.selectedStep = id;
    },
    deleteStep(id) {
      this.$store
        .dispatch("funnel/delete", id)
        .then(() => this.$emit("dispatch"))
        .catch(() => this.$message.error("Erro ao excluir etapa"));
    },
    dispatchScene() {
      this.saving = true;
      clearTimeout(timeout);

      const data = {
        id: this.$route.params.tree,
        items: {
          steps: this.tree.map(f => {
            return {
              id: f.id,
              position_x: parseInt(f.position_x) || 0,
              position_y: parseInt(f.position_y) || 0
            };
          })
        }
      };

      timeout = setTimeout(() => {
        this.$store.dispatch("funnel/exportScene", data).finally(() => {
          this.saving = false;
        });
      }, 1000);
    },
    zoomIn() {
      let deltaScale = Math.pow(1.1, 300 * 0.01);
      this.scale = Math.min(this.scale * deltaScale, 5);

      let deltaOffsetX =
        (this.$el.clientWidth / 2 - this.centerX) * (deltaScale - 1);
      let deltaOffsetY =
        (this.$el.clientHeight / 2 - this.centerY) * (deltaScale - 1);

      this.centerX -= deltaOffsetX;
      this.centerY -= deltaOffsetY;
    },
    zoomOut() {
      let deltaScale = Math.pow(1.1, +300 * -0.01);
      this.scale = Math.max(this.scale * deltaScale, 0.2);

      let deltaOffsetX =
        (this.$el.clientWidth / 2 - this.centerX) * (deltaScale - 1);
      let deltaOffsetY =
        (this.$el.clientHeight / 2 - this.centerY) * (deltaScale - 1);

      this.centerX -= deltaOffsetX;
      this.centerY -= deltaOffsetY;
    },
    centering() {
      let positionOffset = 150;
      let x1 = this.tree.reduce(
          (acc, cur) => Math.max(acc, cur.position_x),
          -Infinity
        ),
        x2 = this.tree.reduce(
          (acc, cur) => Math.min(acc, cur.position_x),
          Infinity
        ),
        xDiff =
          Math.abs(x1 - x2) + this.optionsForChild.width + positionOffset * 2;

      let y1 = this.tree.reduce(
          (acc, cur) => Math.max(acc, cur.position_y),
          -Infinity
        ),
        y2 =
          this.tree.reduce(
            (acc, cur) => Math.min(acc, cur.position_y),
            Infinity
          ) - 300,
        yDiff = Math.abs(y1 - y2) + positionOffset * 2;

      let xScale = Math.abs(this.$el.clientWidth / (xDiff || 1)),
        yScale = Math.abs(this.$el.clientHeight / (yDiff || 1)),
        scale = Math.min(xScale, yScale, 5);

      this.scale = scale;
      this.centerX = (-x2 + positionOffset) * scale;

      if (window.innerWidth < 768) positionOffset = 400;

      this.centerY = (-y2 + positionOffset) * scale;
    }
  },
  watch: {
    modal(v) {
      if (!v) {
        this.stepToEdit = {};
        this.action = null;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.funnel-container {
  flex: 1;
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
}

.saving {
  z-index: 2;
  position: absolute;
  top: 24px;
  right: 24px;
  font-size: 14px;
  margin-inline: 8px;
  color: var(--dark);

  @media screen and (max-width: 991px) {
    top: 80px;
  }

  @media screen and (max-width: 767px) {
    top: unset;
    left: unset;
    right: 8px;
    bottom: 8px;
    font-size: 12px;
  }
}

.controls {
  display: flex;
  position: absolute;

  top: 66px;
  right: 12px;
  z-index: 2;
  margin: 8px;
  border-radius: 4px;
  transition: 0.2s background-color;
  background-color: $neutral-048;

  &:hover {
    background-color: $neutral-076;
  }

  @media screen and (max-width: 991px) {
    top: 72px;
  }
  @media screen and (max-width: 767px) {
    left: 8px;
    top: 92px;

    button {
      width: 32px !important;
      height: 32px !important;
    }

    .percentage {
      height: 32px;
      line-height: 30px;
    }
  }

  button {
    display: flex;
    align-items: center;

    width: 24px;
    height: 24px;
    font-size: 12px;
    background-color: unset;
    transition: 0.2s background-color ease-out;
    border: 1px solid $neutral-300;

    &:hover {
      background-color: $neutral-100;
    }

    &.zoomIn {
      padding-inline: 6px;
      border-right: none;
      border-radius: 4px 0 0 4px;
    }
    &.zoomOut {
      padding-inline: 6px;
      border-left: none;
    }
    &.centering {
      border-radius: 0 4px 4px 0;
    }
    i {
      color: $neutral-700;
    }
  }
}

.percentage {
  width: 100%;
  height: 24px;
  min-width: 52px;
  font-size: 12px;
  line-height: 22px;
  text-align: center;
  border-block: 1px solid $neutral-300;
}
</style>
